import type { ApiRequest, RequestRoutes } from '@/request/requestRouter'
import { RequestAction } from '@/request/requestRouter'
import checkNotificationMiddleware from '@/request/middlewares/notification'
import type { IPage, ReferralUser } from '@/types'

const applyReferral: ApiRequest = {
	action: RequestAction.ApplyReferral,
	endpoint: '{{referralCode}}',
	config: {
		method: 'POST',
		credentials: 'include',
	},
}

const getReferrals: ApiRequest<IPage<ReferralUser>> = {
	action: RequestAction.GetReferrals,
	endpoint: '?page={{page}}&size={{size=5}}',
	config: {
		method: 'GET',
		credentials: 'include',
	},
	afterRequest: async (response: Response): Promise<IPage<ReferralUser>> => {
		return await response.json()
	},
}

export default {
	prefix: '/api/referral',
	middlewares: [checkNotificationMiddleware],
	queries: [applyReferral, getReferrals],
} as RequestRoutes
